exports = module.exports = require("../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-receipt-test{position:absolute !important;top:5% !important;left:11% !important}@media only screen and (max-width: 600px){.modal-content-receipt{width:85% !important;top:75% !important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../lunch-team-client-checkout-msg/node_modules/css-loader!../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./src/components/UI/Modal/modalReceiptTest.scss
// module id = 678
// module chunks = 7